module.exports = __webpack_public_path__ + "static/media/1.question.dac45e31.mp4";